<div class="input-group">
    <select class="custom-select" [(ngModel)]="selectedCategory">
        <option *ngFor="let category of categories" [ngValue]="category">{{ category.fullName }}</option>
    </select>
    <div class="input-group-append">
        <button class="btn btn-primary" (click)="redirect()">{{ 'console.redirect' | translate }}</button>
    </div>
</div>
